module.exports = __webpack_public_path__ + "img/20240227-105838.ec4fdcde.jpeg";